module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_3009.1fe712ce.png";